module.exports = __webpack_public_path__ + "static/media/football-carousel-1366x1024.565bb782.jpg";